import { useEffect, useState } from "react";
import { api } from "./api.ts";

export type City = { id: number; slug: string; name_vi: string; name_en: string; enabled: boolean };
export type Category = {
  id: number;
  parent_id: number | null;
  slug: string;
  name_vi: string;
  name_en: string;
};
export type Meta = { cities: City[]; categories: Category[]; support_url: string | null };

let cache: Promise<Meta> | null = null;

export function loadMeta(): Promise<Meta> {
  cache ??= api<Meta>("/api/meta").catch((e) => {
    cache = null;
    throw e;
  });
  return cache;
}

export function useMeta(): Meta | null {
  const [meta, setMeta] = useState<Meta | null>(null);
  useEffect(() => {
    let live = true;
    loadMeta()
      .then((m) => live && setMeta(m))
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, []);
  return meta;
}
